// libs
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { keyframes } from '@emotion/core';

const loaderSpin = keyframes`
    100% {
        transform: rotate(360deg);        
    }
`;

const loaderFade = keyframes`
    0%  {
        border-top-color: ${({ theme }) => theme.colors.textSecondary};
    }
    20% {
        border-top-color: ${({ theme }) => theme.colors.textSecondary};
    }
    35% {
        border-top-color: white;
    }
    60% {
        border-top-color: ${({ theme }) => theme.colors.textSecondary};
    }
    100% {
        border-top-color: ${({ theme }) => theme.colors.textSecondary};
    }
`;

export const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: ${({ theme }) => `-${theme.spacing.spacing80} 0 0 -${theme.spacing.spacing80}`};
  opacity: 0.85;
  text-align: left;
  border: 4px solid ${({ theme }) => hexToRgb(theme.colors.inverse, 0.7)};
  box-sizing: border-box;
  background-clip: padding-box;
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borders.radius40};
  animation: ${loaderSpin} 0s linear 0.3s forwards;

  &:before,
  &:after {
    content: '';
    position: absolute;
    margin: ${({ theme }) => `-${theme.spacing.spacing20}`};
    box-sizing: inherit;
    width: inherit;
    height: inherit;
    border-radius: inherit; //leaving here
    opacity: 1;
    border: inherit;
    border-color: transparent;
    border-top-color: white;
    animation: ${loaderSpin} 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,
      ${loaderFade} 1.1s linear infinite;
  }

  &:after {
    animation-delay: 0.44s;
  }
`;

export const Container = styled.div<{
    backgroundImage: string;
    width: number;
}>`
  background-color: ${({ theme }) => theme.colors.primary};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  ${({ width, backgroundImage }) => `
        width: ${width}px;
        background-image: url(${backgroundImage});
    `}
`;
